import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    details: [],
    loading: false,
    partialDetails: [],
    dischargePermissionBasedOnStoreDetails: [],
  },
  getters: {
    details: (state) => state.details,
    partialDetails: (state) => state.partialDetails,
    dischargePermissionBasedOnStoreDetails: (state) =>
      state.dischargePermissionBasedOnStoreDetails,
    loading: (state) => state.loading,
  },
  actions: {
    getSingleDischargePermission({ commit }, id) {
      commit("setLoading", true);
      return new Promise((resolve, reject) => {
        ajax
          .get("Inventory/api/DischargePermissionQuery/" + id)
          .then((r) => {
            commit("setDetails", r.data);
            commit("setLoading", false);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    partialDischargePermissions({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "Inventory/api/DischargePermissionQuery/" +
              id +
              "/partial-discharge-permissions"
          )
          .then((r) => {
            commit("setPartialDetails", r.data);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    partialDischargePermissionBasedOnStore({ commit }, { id, storeId }) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "Inventory/api/DischargePermissionQuery/" +
              id +
              "/store/" +
              storeId +
              "/partial-discharge-permission"
          )
          .then((r) => {
            commit("setDischargePermissionBasedOnStoreDetails", r.data);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    confirmDischargePermission({ commit, dispatch }, model) {
      return ajax
        .put("Inventory/api/DischargePermission/confirm", model, {
          headers: { "Content-Type": "application/json" },
        })
        .then(() => {});
    },
    updateForceProcessDischargePermission({ commit, dispatch }, model) {
      return ajax
        .put("Inventory/api/DischargePermission/force-process", model, {
          headers: { "Content-Type": "application/json" },
        })
        .then(() => {});
    },
    setStartTimeOfCheckout({ commit }, id) {
      return ajax
        .put("Inventory/api/DischargePermission/set-start-time-of-checkout", id ,          {headers:{'X-Ignore-Modal':'true'}}
        )
        .then((r) => {});
    },
    rejectDischargePermission({ commit, dispatch }, id) {
      return ajax
        .put(
          "Inventory/api/DischargePermission/reject",
          { dischargePermissionId: id },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {});
    },
    startProcessOfDischargePermissionForCheckout({ commit, dispatch }, id) {
      return ajax
        .put(
          "Inventory/api/DischargePermission/start-process-of-discharge-permission-for-checkout",
          { dischargePermissionId: id },
          {headers:{'X-Ignore-Modal':'true'}}
        )
        .then(() => {});
    },
    createSaleAgentDischargePermission({ commit, dispatch }, model) {
      return ajax
        .post("Inventory/api/DischargePermission", model)
        .then(() => {});
    },
  },
  mutations: {
    setDetails(state, data) {
      state.details = data;
    },
    setPartialDetails(state, data) {
      state.partialDetails = data;
    },
    setLoading(state, value) {
      state.loading = value;
    },
    setDischargePermissionBasedOnStoreDetails(state, data) {
      state.dischargePermissionBasedOnStoreDetails = data;
    },
  },
};
